
    <iframe
      *ngIf="load"
      [style.display]="visible ? null : 'none'"
      [src]="source"
      [width]="iframeWidth"
      [height]="iframeHeight"
      [ngClass]="classes"
      frameborder="0"
      allowfullscreen
      allow="microphone">
    </iframe>
  